import React from "react";
import {
  Container,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  CssBaseline,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import { AddBox as AddBoxIcon, DeleteForever as DeleteForeverIcon, Edit as EditIcon } from "@mui/icons-material";
import { toast } from "react-toastify";
import swal from "sweetalert";
import CurrencyInput from "../common/CurrencyInput";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as dataApi from "../../api/dataApi";

class Income extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      incomes: [],
      member: "tff",
      years: [],
      year: "",
      month: "",
      income: {},
      open: false,
      openEdit: false,
      page: 0,
      rowsPerPage: 50,
      errors: {},
      sortDirection: "desc",
    };
  }

  async componentDidMount() {
    try {
      this.getIncomes();
      this.getYears();
    } catch (error) {
      console.error("Error in componentDidMount", error);
    }
  }

  getIncomes = async () => {
    const { member, year, month } = this.state;
    const incomes = await dataApi.getIncomes(member, year, month);
    if (incomes) {
      incomes.sort((a, b) => new Date(b.incomeDate) - new Date(a.incomeDate));
    }
    this.setState({ incomes: incomes || [] });
  };

  getYears = async () => {
    const years = await dataApi.getYears(this.state.member);
    if (years) {
      this.setState({ years: years.reverse() });
    }
  };

  handleChangePage = (event, newPage) => this.setState({ page: newPage });

  handleChangeRowsPerPage = (event) =>
    this.setState({ rowsPerPage: +event.target.value, page: 0 });

  handleChange = async (e) => {
    await this.setState({ [e.target.name]: e.target.value });
    this.getIncomes();
    this.getYears();
  };

  handleOpen = () =>
    this.setState({ income: {}, errors: {}, open: true });

  handleOpenEdit = (item) => {
    this.setState({
      openEdit: true,
      errors: {},
      income: {
        ...item,
        incomeYear: new Date(item.incomeDate).getFullYear(),
        incomeMonth: new Date(item.incomeDate).getMonth() + 1,
      },
    });
  };

  handleClose = () => this.setState({ open: false });

  handleCloseEdit = () => this.setState({ openEdit: false });

  handleDialogChange = (e) => {
    const errors = { ...this.state.errors, [e.target.name]: "" };
    this.setState({ errors, income: { ...this.state.income, [e.target.name]: e.target.value } });
  };

  handleSave = async () => {
    if (!this.formIsValid()) return;
    this.setState({ open: false });
    const { member, income } = this.state;
    income.amount = parseFloat(income.amount.replace(/[.\s]/g, "") || 0);
    const response = await dataApi.newIncome(member, income);
    if (response) {
      this.getIncomes();
      toast.success("Ny inntekt er lagret");
    } else {
      toast.error("Det skjedde en feil...");
    }
  };

  handleSaveEdit = async () => {
    if (!this.formIsValid()) return;
    this.setState({ openEdit: false });
    const { member, income } = this.state;
    income.amount = parseFloat(income.amount.replace(/[.\s]/g, "") || 0);
    const response = await dataApi.updateIncome(member, income);
    if (response) {
      this.getIncomes();
      toast.success("Inntekt er oppdatert");
    } else {
      toast.error("Det skjedde en feil...");
    }
  };

  handleDeleteIncome = (income) => {
    swal({
      title: "Slette inntekt?",
      icon: "warning",
      buttons: ["Avbryt", "OK"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const year = new Date(income.incomeDate).getFullYear();
        const month = new Date(income.incomeDate).getMonth() + 1;
        const response = await dataApi.deleteIncome(this.state.member, year, month);
        if (response) {
          this.getIncomes();
          swal("Inntekt er slettet!", { icon: "success" });
        } else {
          swal("Noe gikk galt", { icon: "error" });
        }
      }
    });
  };

  formIsValid = () => {
    const errors = {};
    const { income } = this.state;
    if (!income.incomeYear) errors.incomeYear = "Velg år";
    if (!income.incomeMonth) errors.incomeMonth = "Velg måned";
    if (!income.incomeTypeId) errors.incomeTypeId = "Velg type";
    if (!income.amount) errors.amount = "Fyll inn beløp";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  sortBy = (key) => {
    const { incomes, sortDirection } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";

    const sortedData = [...incomes].sort((a, b) =>
      newDirection === "asc" ? a[key] - b[key] : b[key] - a[key]
    );

    this.setState({ incomes: sortedData, sortDirection: newDirection });
  };


  render() {
    const { incomes, member, years, year, month, income, open, openEdit, rowsPerPage, page, errors } =
      this.state;
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <Container maxWidth="lg">
        <main style={{ paddingTop: 80 }}>
          <Paper style={{ padding: 20 }}>
            <CssBaseline />
            <h3 style={{ marginLeft: 15 }}>Inntekter</h3>
            <Grid container spacing={2}>
              <Grid item lg={2}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="member"
                    value={member}
                    onChange={this.handleChange}
                  >
                    <FormControlLabel
                      value="tff"
                      control={<Radio color="primary" />}
                      label="TFF"
                    />
                    <FormControlLabel
                      value="yff"
                      control={<Radio color="primary" />}
                      label="YFF"
                    />
                  </RadioGroup>
                </FormControl>

              </Grid>
              <Grid item lg={2}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel>År</InputLabel>
                  <Select name="year" value={year} onChange={this.handleChange}>
                    <MenuItem value="">Alle</MenuItem>
                    {years.map((yr, index) => (
                      <MenuItem key={index} value={yr}>
                        {yr}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={2}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel>Måned</InputLabel>
                  <Select name="month" value={month} onChange={this.handleChange}>
                    <MenuItem value="">Velg måned</MenuItem>
                    {months.map((m, index) => (
                      <MenuItem key={index} value={m}>
                        {m}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={4}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxIcon />}
                  onClick={this.handleOpen}
                  style={{ float: "right" }}
                >
                  Ny Inntekt
                </Button>
              </Grid>
            </Grid>

            {/* Table */}
            <Paper style={{ marginTop: 20 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Edit</TableCell>
                    <TableCell onClick={() => this.sortBy("year")} style={{ cursor: "pointer" }}>
                      År
                    </TableCell>
                    <TableCell>Måned</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell onClick={() => this.sortBy("amount")} style={{ cursor: "pointer" }}>
                      Beløp
                    </TableCell>
                    <TableCell>Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incomes.length > 0 ? (
                    incomes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((inc, idx) => (
                      <TableRow key={idx}>
                        <TableCell>
                          <Button variant="outlined" onClick={() => this.handleOpenEdit(inc)}>
                            <EditIcon />
                          </Button>
                        </TableCell>
                        <TableCell>{new Date(inc.incomeDate).getFullYear()}</TableCell>
                        <TableCell>{new Date(inc.incomeDate).getMonth() + 1}</TableCell>
                        <TableCell>{inc.incomeTypeName}</TableCell>
                        <TableCell>{inc.amount.toLocaleString("nb-NO")}</TableCell>
                        <TableCell>
                          <Button color="error" onClick={() => this.handleDeleteIncome(inc)}>
                            <DeleteForeverIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        Ingen treff
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 50]}
                component="div"
                count={incomes.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>

            {/* Add/Edit Dialog */}
            <Dialog open={open} onClose={this.handleClose} fullWidth>
              <DialogTitle>Ny Inntekt</DialogTitle>
              <DialogContent>
                <TextField label="Organisasjon" value={member.toUpperCase()} fullWidth disabled />
                <FormControl fullWidth style={{ marginTop: 20 }}>
                  <InputLabel>År</InputLabel>
                  <Select
                    name="incomeYear"
                    value={income.incomeYear || ""}
                    onChange={this.handleDialogChange}
                    error={!!errors.incomeYear}
                  >
                    {years.map((yr, idx) => (
                      <MenuItem key={idx} value={yr}>
                        {yr}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth style={{ marginTop: 20 }}>
                  <InputLabel>Måned</InputLabel>
                  <Select
                    name="incomeMonth"
                    value={income.incomeMonth || ""}
                    onChange={this.handleDialogChange}
                    error={!!errors.incomeMonth}
                  >
                    {months.map((m, idx) => (
                      <MenuItem key={idx} value={m}>
                        {m}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth style={{ marginTop: 20 }}>
                  <InputLabel>Type</InputLabel>
                  <Select
                    name="incomeTypeId"
                    value={income.incomeTypeId || ""}
                    onChange={this.handleDialogChange}
                    error={!!errors.incomeTypeId}
                  >
                    <MenuItem value={1}>Kapitalinntekter</MenuItem>
                    <MenuItem value={2}>Gebyr ved for sen innrapportering</MenuItem>
                    <MenuItem value={3}>Annet</MenuItem>
                  </Select>
                </FormControl>
                <div style={{ marginTop: 20 }}>
                  <label
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      color: "rgba(0, 0, 0, 0.6)",
                      display: "block",
                      marginBottom: "8px",
                    }}
                  >
                    Beløp
                  </label>
                  <CurrencyInput
                    name="amount"
                    placeholder="NOK 1.000"
                    value={income.amount || ""}
                    onChange={this.handleDialogChange}
                    includeThousandsSeparator
                    allowDecimal={false}
                  />
                  {errors.amount && (
                    <Typography color="error" variant="caption">
                      {errors.amount}
                    </Typography>
                  )}
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose}>Avbryt</Button>
                <Button onClick={this.handleSave}>Lagre</Button>
              </DialogActions>
            </Dialog>

            {openEdit && (
              <Dialog open={openEdit} onClose={this.handleCloseEdit} fullWidth>
                <DialogTitle>Rediger Inntekt</DialogTitle>
                <DialogContent>
                  <Grid container spacing={2}>
                    {/* Display the organization */}
                    <Grid item xs={12}>
                      <TextField
                        label="Organisasjon"
                        value={member.toUpperCase()}
                        fullWidth
                        disabled
                      />
                    </Grid>

                    {/* Year Selector */}
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>År</InputLabel>
                        <Select
                          name="incomeYear"
                          value={income.incomeYear || ""}
                          onChange={this.handleDialogChange}
                          error={!!errors.incomeYear}
                        >
                          {years.map((yr, idx) => (
                            <MenuItem key={idx} value={yr}>
                              {yr}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.incomeYear && (
                        <Typography color="error" variant="caption">
                          {errors.incomeYear}
                        </Typography>
                      )}
                    </Grid>

                    {/* Month Selector */}
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Måned</InputLabel>
                        <Select
                          name="incomeMonth"
                          value={income.incomeMonth || ""}
                          onChange={this.handleDialogChange}
                          error={!!errors.incomeMonth}
                        >
                          {months.map((m, idx) => (
                            <MenuItem key={idx} value={m}>
                              {m}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.incomeMonth && (
                        <Typography color="error" variant="caption">
                          {errors.incomeMonth}
                        </Typography>
                      )}
                    </Grid>

                    {/* Amount Input */}
                    <Grid item xs={12}>
                      <div>
                        <label
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: 500,
                            color: "rgba(0, 0, 0, 0.6)",
                            display: "block",
                            marginBottom: "8px",
                          }}
                        >
                          Beløp
                        </label>
                        <CurrencyInput
                          name="amount"
                          placeholder="NOK 1.000"
                          className="MuiInputBase-input MuiInput-input"
                          type="text"
                          includeThousandsSeparator
                          allowDecimal={false}
                          value={income.amount || ""}
                          onChange={this.handleDialogChange}
                        />
                        {errors.amount && (
                          <Typography color="error" variant="caption">
                            {errors.amount}
                          </Typography>
                        )}
                      </div>
                      {errors.amount && (
                        <Typography color="error" variant="caption">
                          {errors.amount}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseEdit} color="primary">
                    Avbryt
                  </Button>
                  <Button onClick={this.handleSaveEdit} color="primary">
                    Lagre
                  </Button>
                </DialogActions>
              </Dialog>
            )}

          </Paper>
        </main>
        <ScrollToTopBtn />
      </Container>
    );
  }
}

export default Income;
